import { render } from "./ModalTwoAuth.vue?vue&type=template&id=5d724092&scoped=true&ts=true"
import script from "./ModalTwoAuth.vue?vue&type=script&lang=ts"
export * from "./ModalTwoAuth.vue?vue&type=script&lang=ts"

import "./ModalTwoAuth.vue?vue&type=style&index=0&id=5d724092&lang=stylus&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d724092"]])

export default __exports__